/**
* Fav Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Fav Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'fav-treatments',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.fav-treatments' ).length ) {
        $( '.fav-treatments' ).each( function( index, element ) {
          let currentTabpanel = $( this ).find( '.fav-treatments__tabpanel.is-open' ).attr( 'id' );
          const select = $( this ).find( '.fav-treatments__select' );
          const announcement = $( this ).find( '.fav-treatments__announcement' );

          $( document ).on( 'change', '.js-fav-treatments-form', function( event ) {
            event.preventDefault();
            const formData = $( this ).serializeArray();
            let updatedTabpanel = currentTabpanel;
            let inputType = '';

            $( formData ).each( function( index, value ) {
              if ( value.value !== currentTabpanel ) {
                updatedTabpanel = value.value;
                inputType = value.name;
              }
            } );

            /* Show the slider and update aria attribute */

            $( `#${currentTabpanel}` ).removeClass( 'is-open' );
            $( `#${currentTabpanel}` ).attr( 'aria-hidden', true );
            $( `#${updatedTabpanel}` ).addClass( 'is-open' );
            $( `#${updatedTabpanel}` ).attr( 'aria-hidden', false );

            currentTabpanel = updatedTabpanel;

            /* make sure form fields have same value */
            if ( inputType === 'fav-treatments-select' ) {
              $( this ).find( `.fav-treatments__radio-input[value="${currentTabpanel}"]` ).prop( 'checked', true );
            } else {
              select.val( currentTabpanel );
            }

            /* announce the slider has been displayed */
            const selectedTitle = $( `#${select.attr( 'id' )} option:selected` ).text();
            announcement.text( `${selectedTitle} slider is displayed` );

            return false;
          } );
        } );
      }

      $( '.fav-treatments__card' ).on( 'mouseenter', function() {
        if ( ! mobileSize.matches ) {
          $( this ).find( '.fav-treatments__description-wrapper' )
              .stop( true, true )
              .slideDown( 300 );
        }
      } );

      $( '.fav-treatments__card' ).on( 'mouseleave', function() {
        if ( ! mobileSize.matches ) {
          $( this ).find( '.fav-treatments__description-wrapper' )
              .stop( true, true )
              .slideUp( 300 );
        }
      } );

      const mobileSize = window.matchMedia( '(max-width: 767px)' );
      mobileSize.addEventListener( 'change', handleMobileChange );

      function handleMobileChange( event ) {
        console.log( event.matches );
        if ( event.matches ) {
          $( '.fav-treatments__description-wrapper' ).css( 'display', '' );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'fav-treatments', COMPONENT );
} )( app );
